module.exports = __webpack_public_path__ + "static/img/nailao.79118126.png";